<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="main-title">首页</div>
        <div id="content" style="width:80%;margin:0 auto 50px;text-align: center">
        </div>
<!--         <div class="main-sub" ></div>-->
        <div class="con-list flex">
          <div
            class="con-item"
            :class="{
              known:item.is_skip==1&&item.is_verify==0,
              skip:item.is_skip==1&&item.is_verify==1,
              next:item.is_skip==0&&item.is_verify==1,
              // success: item.action == 0,
              // warning: item.action == 1,
              // fail: item.action == 2,
            }"
            v-for="(item, index) in list"
            :key="index"
            @click="toLink(item.link_url,item.mark,item.link_type)"
          >
         
            <div class="con-top flex">
              <el-image class="icon-img" v-if="item.icon" :src="item.icon"></el-image>
              {{ item.name }}
            </div>
            <div v-if="item.deadline" class="tjtime">提交截止日期：{{ item.deadline }}</div>
            <div class="tjtime" v-if="item.name=='参展须知'">有问题可联系：010-68512208</div>
            <div class="con-bottom flex">
              <div>
                <div class="con-status read" v-if="item.action == 2">已读</div>
                <div class="con-status warning" v-if="item.action == 1">跳过</div>
                <div class="con-status uncompleted" v-if="item.action == 0">未完成</div>
                <div class="con-status warning" v-if="item.action == 3">审核中</div>
                <div class="con-status read" v-if="item.action == 4">已完成</div>
              </div>
            <div class="con-more">
               <i class="el-icon-arrow-right"></i>
            </div>
            </div>
            <!-- <div
              class="con-sub"
              v-if="item.menu_mark == 'product' && totals > 0"
            >
              {{ totals }}件产品
            </div> -->
            
          </div>
        </div>
        <div class="conf-btn flex">
          <!-- 可跳过需要验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==1">
             <div class="btn" @click="next('skip')">跳过</div>
             <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
           <!-- 可跳过无需验证 -->
          <template  v-if="detail.is_skip==1&&detail.is_verify==0">
            <div class="btn next_btn" @click="next('known')" v-if="detail.is_skip==1&&detail.is_verify==0">已知悉</div>
          </template>
          <!-- 不可跳过需要验证 -->
          <template  v-if="detail.is_skip==0&&detail.is_verify==1">
              <div class="btn next_btn" @click="next('next')">下一步</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  skipOrReadStep,
  getDetail,
  getConfig,


  getmyMenu, clientMenu_detail
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "conference",
  data() {
    return {
      loading: false,
      active: 0,
      content: {
        title_brief: "",
      },
      list: [],
      totals: 0,
      detail:{},
      stepMenuList:[]
    };
  },
  mounted() {
    this.getMenu()
  },
  created() {

  },
  methods: {
    // 获取页面信息
    getMenu() {
      let that=this;
      let data = this.$qs.stringify({type: JSON.parse(localStorage.getItem("userdata")).type});
        getmyMenu(data).then((res) => {
            if (res.code == 1) {
              let { data } = res;
                console.log(data,"data")
              this.stepMenuList=data;
              let stepMenuList = data;
              let index = stepMenuList.findIndex(function (item) {
                return item.link_url == "/conference";
              });
              that.detail=stepMenuList[index]
              if(stepMenuList[index].children&&stepMenuList[index].children.length>0){
                that.list=stepMenuList[index].children;
              }
              this.getContent(stepMenuList[index].id)
              that.active = index;
            }
          }).catch((err) => {
            console.log(err);
          });
    },
     // 获取内容
    getContent(id) {
      this.loading = true;
      let data = this.$qs.stringify({id:id});
      clientMenu_detail( data ).then((res) => {
          //console.log(res, "======获取内容");
          if (res.code == 1) {
            this.loading = false
            let { data } = res;
            this.content = data.content;
            document.getElementById('content').innerHTML=data.content
            // this.content.title_brief = data[0].step.title_brief;
            // //获取二级展示信息及二级进度
            // this.getConfig(this.id);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    // //获取二级进度配置
    // getConfig(parent_menu_id) {
    //   getConfig({ parent_menu_id })
    //     .then((res) => {
    //       //console.log(res, "======获取二级进度配置");
    //       if (res.code == 200) {
    //         //console.log(res.data, '====res.data')
    //         this.list = res.data;
    //         this.getStepStatus(this.content.menu_mark);
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
 
    //获取列表
    getList() {
      let data = this.$qs.stringify({
        page_size: 10,
        page_no: 1,
        keywords: "",
      });
      // productList(data)
      //   .then((res) => {
      //     //console.log(res, "======获取列表");
      //     if (res.code == 200) {
      //       let { data } = res.data;
      //       this.totals = data.product_total;
      //     }
      //   })
      //   .catch((err) => {});
    },
    // 跳转页面
    toLink(path,mark,link_type) {
        console.log(mark,"mark")
      if (link_type==2) {
          window.open(path, "_blank");
          this.skipOrReadStep(2,mark)
      } else {
        this.$router.push({
          path,
          query:{
            mark
          }
        });
      }
    },
    // 跳转下一步
    next(type) {

      if(type=='next'){//下一步

        if(this.detail.action==1||this.detail.action==4){
          this.toPath();
        }else{
          this.$message.warning("请完善信息!")
        }

      }else if(type=='skip'){//跳过
          this.skipOrReadStep(1,this.detail.mark)
      }else if(type=='known'){//已知悉

          this.skipOrReadStep(2,this.detail.mark)
      }
    },
    // 跳过或者已知悉
    skipOrReadStep(action,mark){
      let data={
        type:JSON.parse(localStorage.getItem("userdata")).type,
        action,
        mark
      }
      skipOrReadStep(data).then(res=>{

        if(res.code==1){
          this.$message.success("操作成功")
            if(mark!=="ExNotice"){
                this.toPath()
            }else{
              this.getMenu()
            }

        }else{
          this.$message.error(res.msg)
        }

      }).catch(err=>{
        console.log(err)
      })

    },
    toPath() {

      this.active = this.active + 1;
      let { link_url, menu_title, id } = this.stepMenuList[this.active];

      // if (link_url == "/exhibitorManual" || link_url == "/standPrepare") {
        this.$router.push({
          path: link_url
        });
      // } else {
      //   this.$router.push({
      //     path: link_url
      //   });
      // }
    },
    
  },
};
</script>

<style lang="scss" scoped>
.conf-btn {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
}
.tjtime{
    margin-top: 12px !important;

  }
.main-sub {
  // width: 946px;
}
.red {
  color: #ff005a;
}
.con-bottom{
  // width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 42px;
  z-index: 9;
  position: relative;
}
.con-list {
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  .known{
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      z-index: 1;
      background: linear-gradient(90deg, #57CCF1 0%, #2E81EB 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #57CCF1 0%, #2E81EB 100%);
      border-radius: 18px;
      filter: blur(12px);
    }
  }
  .skip{
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      z-index: 1;
      background: linear-gradient(90deg, #FFDF69 0%, #F7971E 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient(90deg, #FFDF69 0%, #F7971E 100%);
      border-radius: 18px;
      filter: blur(12px);
    }
  }
  .next{
    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 18px;
      z-index: 1;
      background: linear-gradient( 135deg, #FF99AC 0%, #FF3961 100%);
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 50%;
      width: 80%;
      height: 20px;
      z-index: 1;
      transform: translateX(-50%);
      background: linear-gradient( 135deg, #FF99AC 0%, #FF3961 100%);
      border-radius: 18px;
      filter: blur(12px);
    }
  }
  .con-item {
    // flex-direction: column;
    width: 263px;
    // height: 113px;
    margin-right: 22px;
    // background: linear-gradient(90deg, #87EECE 0%, #58D6D8 100%);
    border-radius: 15px;
    box-sizing: border-box;
    padding: 33px 33px 33px 23px;
    flex-wrap: wrap;
    position: relative;
    cursor: pointer;
    margin-bottom: 20px;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: 0px;
    //   left: 0;
    //   width: 100%;
    //   height: 100%;
    //   border-radius: 15px;
    //   z-index: 1;
    //   background: linear-gradient(90deg, #87EECE 0%, #58D6D8 100%);
    // }
    // &::after {
    //   content: "";
    //   position: absolute;
    //   bottom: 0px;
    //   left: 50%;
    //   width: 80%;
    //   height: 20px;
    //   z-index: 1;
    //   transform: translateX(-50%);
    //   background: linear-gradient(90deg, #6CEBC3 0%, #2ECCCF 100%);
    //   border-radius: 8px;
    //   filter: blur(12px);
    // }
    .con-status {
      // position: absolute;
      // top: 8px;
      // right: 8px;
      width: 58px;
      height: 22px;
      font-size: 12px;
      line-height: 22px;
      text-align: center;
      background: #fff;
      border-radius: 7px;
    }
    .read{
      color: #1ac484 !important;
    }
    .uncompleted{
      color: #ff4d64 !important;
      
    }
    .warning{
      color: #ffb800 !important;
    }
    .con-top {
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      align-items: center;
      align-self: flex-start;
      z-index: 9;
      position: relative;
      .icon-img {
        width: 48px;
        height: 48px;
        margin-right: 15px;
      }
    }
    .con-sub {
      width: 100%;
      font-size: 15px;
      color: #fff;
    }
    .con-more {
      font-size: 24px;
      color: #fff;
      cursor: pointer;
      // text-align: right;
      // align-self: flex-end;
      // position: relative;
      z-index: 9;
    }
    &:hover::before {
      // background: linear-gradient(90deg, #6CEBC3 0%, #2ECCCF 100%);
    }
    &:hover::after {
      // background: linear-gradient(90deg, #6CEBC3 0%, #2ECCCF 100%);
    }
  }
  // .con-item:first-child{
  //   &::before{
  //     background: linear-gradient(135deg, #7996F7 0%, #F7A7EE 100%);
  //   }
  //   &::after {
  //     background: linear-gradient(135deg, #7996F7 0%, #F7A7EE 100%);
  //   }
  //   &:hover::before {
  //     background: linear-gradient(135deg, #547CF6 0%, #FB93EB 100%);
  //   }
  //   &:hover::after {
  //     background: linear-gradient(135deg, #547CF6 0%, #FB93EB 100%);
  //   }
  // }
  // .con-item:nth-child(2){
  //   &::before{
  //     background: linear-gradient(135deg, #FC9B5B 0%, #D694C3 51%, #7A73FB 100%);
  //   }
  //   &::after {
  //     background: linear-gradient(135deg, #FF842C 0%, #CC7AB7 51%, #544FFF 100%);
  //   }
  //   &:hover::before {
  //     background: linear-gradient(135deg, #FF842C 0%, #CC7AB7 51%, #544FFF 100%);
  //   }
  // }
  // 已通过状态
  .success {
    background: #f1fcf9;
    border-color: #1ac484;
    .con-status {
      background: #fff;
      color:#1ac484;
    }
  }
  // 未通过状态
  .fail {
    background: #ffedf0;
    border-color: #ff4d64;
    .con-status {
      background: #fff;
      color:#ff4d64;
    }
  }
  // 审核状态
  .warning {
    background: #fff9e9;
    border-color: #ffb800;
    .con-status {
      background: #fff;
      color:#ffb800;
     
    }
  }
}

@media only screen and (max-width: 767px) {
  .content{
    padding: 30px 0 130px 0;
   
  }
  .con-status{
    font-size: 12px !important;
  }
  .con-more{
    font-size: 20px !important;
  }
  .con-list .con-item .con-top .icon-img{
    width: 38px !important;
    height: 38px !important;
  }
  .btn{
    font-size: 15px !important;
    min-width: 130px !important;
  }
  .con-top{
    font-size: 12px !important;
  }
  .con-item{
    width: 100% !important;
    padding: 23px !important;
  }
  
  .con-list{
    // margin: 23px;
    padding: 30px 0 120px 20px;
  }
  .conf-btn{
    bottom: 60px;
  }
  

}
</style>